import { FilterBuilder } from '../Types';

import { CanonicalBills } from 'ha/constants/Filters';

const facilitiesToInclude = [
  'water_cost',
  'gas_cost',
  'electricity',
  'internet',
];

const billsBuilder: FilterBuilder = params => {
  const bills = params.bills;

  if (!bills) {
    return '';
  }

  return {
    [CanonicalBills.Included]: facilitiesToInclude
      .map(facility => `facility_${facility}_included:yes`)
      .join(' AND '),
    [CanonicalBills.Excluded]: facilitiesToInclude
      .map(facility => `facility_${facility}_included:no`)
      .join(' OR '),
  }[bills];
};

export default billsBuilder;
